import { render } from "./StairVibration.vue?vue&type=template&id=1ee2a7b1"
import script from "./StairVibration.vue?vue&type=script&lang=js"
export * from "./StairVibration.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__